import React from 'react';
import { Button } from "primereact/button";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import NoteHistorique from "../NoteHistorique";

export default function NoteSection({
  isOpen,
  onToggle,
  note,
  setNote,
  savingNote,
  onSaveNote,
  idLead,
  refreshKey
}) {
  return (
    <>
      <div className="accordion-header" onClick={onToggle}>
        <span className="accordion-title">
          <i className="pi pi-comments"></i> Notes & Historique
        </span>
        {isOpen ? (
          <ExpandLessIcon sx={{ fontSize: 18, color: "#6b7280" }} />
        ) : (
          <ExpandMoreIcon sx={{ fontSize: 18, color: "#6b7280" }} />
        )}
      </div>

      {isOpen && (
        <>
          <div className="grid mb-3">
            <div className="col-12">
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <input
                  type="text"
                  className="clean-input"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Écrire une note..."
                  style={{ flex: 1 }}
                />
                <Button
                  label={savingNote ? "..." : "Ajouter"}
                  className="brand-btn-primary p-button-sm"
                  style={{ height: "38px", fontSize: "13px" }}
                  onClick={onSaveNote}
                  disabled={savingNote || !note.trim()}
                />
              </div>
            </div>
          </div>

          <div className="grid mb-2">
            <div className="col-12">
              <NoteHistorique
                idLead={idLead}
                refreshKey={refreshKey}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
}